// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1995":"741921afa0346fcc","2750":"6aaf771051860cb9","3479":"6c7c0a9ba0962f52","8862":"726c1b7dfbc3f752"}[chunkId] + ".css";
};